require('./accountRetentionsTableRow.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
// @ components
const { LabelDate } = require('commonsComponents/labelDate');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
// @ helpers
const { toCamelCase } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
//@core
const { getLanguage } = require('core/i18n').i18n;
//@constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { EMPTY_CONCEPT } = require('constants/index');
const { [getLanguage()]:{ DATE_FORMAT_WITH_DASHES } } = require('constants/contactCenter/dateFormatTypes');

class AccountRetentionsTableRow extends React.Component {

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildCCAdditionalColumns(){
        const {immTransaction} = this.props;
        const reason = toCamelCase(immTransaction.get('reason')) || EMPTY_CONCEPT;
        const startDate = immTransaction.get('startDate');
        const endDate = immTransaction.get('endDate');

        const additionalCCColumns = {}

        additionalCCColumns.reason = (
            <OKTableCell className="account-retentions-table-row__cell-reason">
                <p className="account-retentions-table-row__cell-reason-content">{reason}</p>
            </OKTableCell>
        );
        additionalCCColumns.formattedStartDate = (
            <OKTableCell className="account-retentions-table-row__cell-start-date">
                <p className="account-retentions-table-row__cell-start-date-content">
                    {startDate ? DateHelper.customFormat(startDate, DATE_FORMAT_WITH_DASHES) : EMPTY_CONCEPT}
                </p>
            </OKTableCell>
        );
        additionalCCColumns.formattedEndDate = (
            <OKTableCell className="account-retentions-table-row__cell-end-date">
                <p className="account-retentions-table-row__cell-end-date-content">
                    {endDate ? DateHelper.customFormat(endDate, DATE_FORMAT_WITH_DASHES) : EMPTY_CONCEPT}
                </p>
            </OKTableCell>
        );

        return additionalCCColumns;
    }

    render() {
        const {
            id,
            immScreen,
            immTransaction,
        } = this.props;
        const description = toCamelCase(immTransaction.get('description'));
        const additionalCCColumns = __CONTACT_CENTER__ ? this.buildCCAdditionalColumns() : null
        const plainAmountObject = getPlainAmountObject(immTransaction.get('balance'));
        const language = getLanguage();
        const dateLabel = (
            <LabelDate
                date={immTransaction.get('date')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );
        const dateLabelEndDate = (
            <LabelDate
                date={immTransaction.get('endDate')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );
        const balance = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
        let row;
        let contactCenterRenderComponent;
        if(additionalCCColumns) {
            contactCenterRenderComponent = (
                <ContactCenterRender>
                    {additionalCCColumns.reason}
                    {additionalCCColumns.formattedStartDate}
                    {additionalCCColumns.formattedEndDate}
                </ContactCenterRender>
            )
        }

        if (immScreen.get('isMobile')) {
            row = (
                <OKTableCell className="account-retentions-table-row__cell-mobile">
                    <span className="pull-left account-retentions-table-row__cell-date-mobile">
                        <WebappRender>
                            {dateLabel} - {dateLabelEndDate}
                        </WebappRender>
                        <ContactCenterRender>
                            {dateLabel}
                        </ContactCenterRender>
                    </span>
                    <div className="text-right account-retentions-table-row__cell-balance-mobile">
                        {balance}
                    </div>
                    <p className="account-retentions-table-row__cell-description-mobile">
                        {description}
                    </p>
                </OKTableCell>
            );
        } else {
            row = (
                <React.Fragment>
                    <OKTableCell className="account-retentions-table-row__cell-date">
                        <WebappRender>
                            {dateLabel} - {dateLabelEndDate}
                        </WebappRender>
                        <ContactCenterRender>
                            {dateLabel}
                        </ContactCenterRender>
                    </OKTableCell>
                    <OKTableCell className="account-retentions-table-row__cell-description">
                        <p className="account-retentions-table-row__cell-description-content">
                            {description}
                        </p>
                    </OKTableCell>
                    {contactCenterRenderComponent}
                    <OKTableCell className="account-retentions-table-row__cell-balance">
                        {balance}
                    </OKTableCell>
                </React.Fragment>
            );
        }

        return <OKTableRow id={id}>{row}</OKTableRow>;
    }
}

AccountRetentionsTableRow.propTypes = {
    id: PropTypes.string,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object,
    onRowClick: PropTypes.func,
}

AccountRetentionsTableRow.defaultProps = {
    className: '',
    onRowClick: function () { }
}

export default connect(
    state => ({
        immScreen: state.screen,
    }),
    null
)(AccountRetentionsTableRow);